/* eslint-disable */
import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import groupBy from 'lodash.groupby'
import CompanyGroup from './CompanyGroup'

class CampusGroup extends PureComponent {
  state = { collapsed:true };

  toggleCampus = ()=>{
    this.setState({collapsed: !this.state.collapsed})
  };

  setCollapsed = ({isSingleCampus})=>{
    // Expand group if single campus returned
    // from search
    // ======================================
    this.setState({collapsed: !isSingleCampus})
  };

  componentWillMount() {
    // Initial Render
    // ==============
    this.setCollapsed(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.setCollapsed(nextProps)
  }

  renderCompanies = ()=>{
    const {data} = this.props;
    const {collapsed} = this.state;
    if(collapsed) return <noop></noop>;

    // Group by Companies
    // ==================
    const grouped = groupBy(data,'VENDOR_NAME');

    // Get array of Companies
    // ======================
    const groups = Object.keys(grouped);

    // Single Company Returned?
    // ========================
    const isSingleCompany = groups.length === 1;

    // display Company Groups
    // ======================
    return (
      groups.map((prop,i)=>{
        return <CompanyGroup
          isSingleCompany={isSingleCompany}
          key={`Company-Group-${i}`}
          data={grouped[prop]}
          company={prop}/>
      })
    );
  };

  render(){
    const {title} = this.props;
    const {collapsed} = this.state;
    // Set arrow direction for collapsed
    // =================================
    let arrowClass = 'glyphicon ';
    if(collapsed) {
      arrowClass += 'glyphicon-chevron-right';
    } else {
      arrowClass += 'glyphicon-chevron-down';
    }

    return (
      <div className="panel panel-info">
        <a onClick={this.toggleCampus}>
          <div className="panel-heading">
            <h4>
              <span className={arrowClass} aria-hidden="true"></span>
              &nbsp;{title}
            </h4>
          </div>
        </a>
          {this.renderCompanies()}
      </div>
    );
  }
}

CampusGroup.propTypes = {
  isSingleCampus: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired
};
CampusGroup.defaultProps = {
  isSingleCampus:false,
  title: '',
  data: []
};

export default CampusGroup


// WEBPACK FOOTER //
// ./src/components/Payments/CampusGroup.jsx